var _a;
import React from 'react';
import styled from 'styled-components';
const autentiLogo = (_a = require('../media/Logos/autentiLogo.svg')) === null || _a === void 0 ? void 0 : _a.default;
const Header = styled.div `
  height: 64px;
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0px 4px 32px rgba(105, 125, 142, 0.08);
`;
const HeaderLogo = styled.img `
  width: 84px;
  height: 16px;
`;
const HeaderComponent = () => (React.createElement(Header, null,
    React.createElement(HeaderLogo, { src: autentiLogo, alt: "" })));
export default HeaderComponent;
